import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Divider,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdFileDownload } from 'react-icons/md';
import { observer } from 'mobx-react';

import ImageUploader from './components/imageUploader';
import SelectionTreeView from './components/selectionTreeView';
import CustomResolution from './components/customResolution';
import { imageStore } from './stores/imageStore';
import { processAndDownloadImages } from './utils/imageUtils';
import { sendEvent } from '../../common/analytics';

const Resizer = observer(() => {
  const panelBorder = useColorModeValue('gray.200', 'gray.700');
  const leftBg = useColorModeValue('gray.50', 'gray.800');
  const rightBg = useColorModeValue('white', 'gray.900');
  const cardShadow = useColorModeValue('sm', 'none');

  useEffect(() => {
  }, []);

  const handleDownload = () => {
    processAndDownloadImages(imageStore.images, imageStore.resizeOutputs);
    sendEvent('ImageResizer', 'Image-Upload', imageStore.images.length.toString());
  };

  const isButtonEnabled =
    imageStore.images.length > 0 && imageStore.resizeOutputs.length > 0;

  return (
    <Box maxW="960px" mx="auto">
      {/* ── Main card: 2-column layout ── */}
      <Box
        borderWidth="1px"
        borderColor={panelBorder}
        borderRadius="2xl"
        overflow="hidden"
        shadow={cardShadow}
      >
        <Flex direction={{ base: 'column', md: 'row' }} align="stretch">
          {/* ── Left: Upload area ── */}
          <Box
            w={{ base: '100%', md: '40%' }}
            bg={leftBg}
            p={6}
            borderRightWidth={{ md: '1px' }}
            borderBottomWidth={{ base: '1px', md: '0' }}
            borderColor={panelBorder}
          >
            <ImageUploader store={imageStore} />
          </Box>

          {/* ── Right: Selection + Download ── */}
          <Box flex={1} bg={rightBg} p={6} display="flex" flexDirection="column">
            <Text fontSize="xl" fontWeight="bold" mb={1}>
              Image Resizer
            </Text>
            <Text fontSize="sm" color="gray.500" mb={5}>
              Resize your App Store and Google Play Store images in bulk
            </Text>

            {/* Platform checkboxes + custom resolution */}
            <Box flex={1} overflowY="auto">
              <SelectionTreeView store={imageStore} />
              <Box mt={4}>
                <CustomResolution store={imageStore} />
              </Box>
            </Box>

            {/* Divider + Download button */}
            <Divider my={4} borderColor={panelBorder} />
            <Button
              w="full"
              size="lg"
              colorScheme="blue"
              leftIcon={<Icon as={MdFileDownload} />}
              isDisabled={!isButtonEnabled}
              onClick={handleDownload}
              borderRadius="lg"
              fontWeight="semibold"
            >
              Download Resized Images
            </Button>
          </Box>
        </Flex>
      </Box>

    </Box>
  );
});

export default Resizer;
